export default "__VITE_ASSET__DwyYZyW1__"